import { createSelector } from 'reselect';

const selectDomain = (state) => state.gameLog;

/** Whether a move did anything to show: moving your own cards around (arranging) says nothing, and isn't replayed. */
const saysSomething = (entry) => ['notes', 'flips', 'cards', 'pokemon'].some(key => (entry[key] || []).length > 0);

/** The moves to replay for `gameId`, oldest first, each with its board; null until they've loaded. */
export const selectReplayEntries = createSelector(
  [selectDomain, (state, { gameId }) => gameId],
  (state, gameId) => {
    const replay = state.get('replay');
    return replay && replay.gameId === gameId ? replay.entries.filter(entry => entry.board && saysSomething(entry)) : null;
  },
);

/** The log's entries for `gameId`, oldest first, or null until they've loaded. */
export const selectLogEntries = createSelector(
  [selectDomain, (state, { gameId }) => gameId],
  (state, gameId) => (state.get('gameId') === gameId ? state.get('entries') : null),
);
